import React, {Component} from 'react';
import {getWeChatTags, getWeChatTypeAndMassNumber} from "../actions/weiChat";
import { Cascader } from 'antd';

class WeiChatTagSelect extends Component {

    constructor(props){
        super(props);
        this.state = {
            tags : [],
            mediaCode : this.props.mediaCode,
            restCount : 0,
            weChatType: "1"
        };
    }

    checkedTagId = 0;

    componentDidMount() {
        this.loadWeiChatTags();
        this.getMassNumber();
    }

    loadWeiChatTags = () => {
        getWeChatTags({mediaCode: this.state.mediaCode} ,(res) => {
            this.setState({
                tags : res
            })
        })
    };

    getMassNumber = () =>{
        getWeChatTypeAndMassNumber({mediaCode: this.state.mediaCode} ,(res) => {
            let dyhcount = 1;// 订阅号总数
            let fwhcount = 4;// 服务号总数
            let restCount = 0;
            if(res.gzhtype === "1"){
                restCount = dyhcount - parseInt(res.count);
            }else {
                restCount = fwhcount - parseInt(res.count);
            }
            this.setState({restCount,weChatType : res.gzhtype})
        })
    };

    onChange = (value) =>{
        if(value.length === 0){
            this.checkedTagId = 0;
        }else if(value.length === 1){
            this.checkedTagId = value[0];
        }else if(value.length === 2){
            this.checkedTagId = value[1];
        }
        console.log("this.checkedTagId=========",this.checkedTagId)
    };

    options = [
        {
            value: 0,
            label: '全部用户',
            children: []
        },
        {
            value: -1,
            label: '按标签选择',
            children: []
        }
        ];

    render() {
        this.options[1].children = [];
        this.state.tags.map(item =>{
            this.options[1].children.push({value: item.groupId,label:item.name})
        });
        return (
            <div>
                <Cascader options={this.options} onChange={this.onChange} placeholder="请选择"  style={{float:"left",marginRight:"10px"}}/>
                <div style={{lineHeight:"30px"}}>{this.state.weChatType === "1" ? "您今天还能群发" + this.state.restCount +"次消息" : "您本月还能群发" + this.state.restCount +"次消息"}</div>
            </div>

        );
    }
}

export default WeiChatTagSelect;